import type { CookieService } from "@/src/infrastructure/cookieconsent/CookieService";

import { CookieCategory } from "@/src/infrastructure/cookieconsent/CookieCategory";

export const auth0Cookie: CookieService<CookieCategory.NECESSARY> = {
  category: CookieCategory.NECESSARY,
  name: "Auth0",
  privacyPolicyUrl: "https://auth0.com/privacy",
  purpose: "Authentification à l’espace sociétaire",
};
